// extracted by mini-css-extract-plugin
export var cardsContainer = "more-cards-module--cardsContainer--a99c8";
export var container = "more-cards-module--container--f958c";
export var headline = "more-cards-module--headline--70f73";
export var headlineContainer = "more-cards-module--headlineContainer--9f880";
export var moreCard = "more-cards-module--moreCard--8db88";